import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const SubNav = styled.nav`
  background-color: ${(props) => props.theme.subMenu.background};
  box-sizing: border-box;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.25);
  padding: 0px 55px;
`;

export const Ul = styled.ul`
  padding: 1rem 0px;
  margin: 0;

  li:not(:first-child) {
    border-left: solid 2px ${(props) => props.theme.subMenu.foreground};
  }
`;

export const Li = styled.li`
  display: inline-block;
  padding: 0px 20px;
`;

export const StyledSubNavLink = styled(NavLink)`
  display: block;
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  color: ${(props) => props.theme.menu.foreground};
  transition: all 0.2s ease 0s;

  &.active {
    color: ${(props) => props.theme.primary};
  }

  &:hover {
    color: ${(props) => props.theme.primary};
  }
`;
